/* OXS PDP — sticky add-to-cart bar: show on scroll past buy box; button triggers main add-to-cart */
(() => {
  const sticky = document.getElementById('pdpSticky');
  const hero = document.querySelector('.pdp-hero');
  if (sticky && hero && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0, rootMargin: '0px 0px -60% 0px' });
    io.observe(hero);
  }
  const btn = sticky && sticky.querySelector('[data-sticky-add]');
  if (btn) {
    btn.addEventListener('click', () => {
      const mainSubmit = document.querySelector('product-form [type="submit"]');
      if (mainSubmit) mainSubmit.click();
      else window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }
})();
